import { makeOpenApiMethod } from "../make-openapi-method";

export const getChainNonprofits = makeOpenApiMethod("/chain/{chainId}/nonprofits", "get", 200);

export const getImpact = makeOpenApiMethod("/impact", "get", 200);

export const getCumulativeImpact = makeOpenApiMethod("/chain/{chainId}/cumulativeImpact", "get", 200);

export const postSelectNonprofit = makeOpenApiMethod("/selectNonprofit", "post", 201);

export const postTransaction = makeOpenApiMethod("/transaction", "post", 201);

export const putTransaction = makeOpenApiMethod("/transaction/{transactionId}", "put", 204);

export const postCart = makeOpenApiMethod("/cart", "post", 200);

export const postChainEligibleNonprofitsForCart = makeOpenApiMethod(
  "/chain/findEligibleNonprofitsForCart",
  "post",
  200
);

export const postLogs = makeOpenApiMethod("/logs", "post", 200);

export const postExperimentSession = makeOpenApiMethod("/experimentSession", "post", 200);

export const updateSubscription = makeOpenApiMethod("/subscriptions/updateSubscriptionNonprofit", "post", 200);

export const postFindOrCreateSubscription = makeOpenApiMethod("/subscriptions/findOrCreateSubscription", "post", 200);

export const postProductDetailsPage = makeOpenApiMethod("/productDetailsPage", "post", 200);
